<template>
  <div
    class="key-capture"
    style="display: none;"
  ></div>
</template>

<script>
export default {
  computed: {
    inputtingText() {
      return this.$store.getters['appState/inputtingText'];
    },
  },
  mounted() {
    this.handleGlobalKeyDown = event => {
      if (this.inputtingText) return;
      this.$emit('keydown', event.key);
    };
    window.addEventListener('keydown', this.handleGlobalKeyDown);
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.handleGlobalKeyDown);
  },
};
</script>
